var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement, useState } from 'react';
import { Hidden, Search, Visible } from '../icon';
import Enhancer from './enhancer';
import EnhancerRight from './enhancer-right';
import IconLeft from './icon-left';
import { inputStyle, inputWrapperStyle } from './styles';
function renderIcon(originalIcon, size, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
props) {
    var _a;
    // Check if the Icon has a provided custom size prop already
    return cloneElement(originalIcon, Object.assign(Object.assign({}, props), { 
        // Handle large buttons having medium sized Icons by default, and small / medium as defined
        size: (_a = originalIcon.props.size) !== null && _a !== void 0 ? _a : (size === 'large' ? 'medium' : size) }));
}
function InputInternal(_a, ref) {
    var { disabled = false, enhancerRight, error = false, iconLeft, inverted = false, onBlur, onFocus, passwordVisibilityAriaLabel = ({ isPasswordVisible }) => `${isPasswordVisible ? 'Hide' : 'Show'} password text`, size = 'medium', type } = _a, restProps = __rest(_a, ["disabled", "enhancerRight", "error", "iconLeft", "inverted", "onBlur", "onFocus", "passwordVisibilityAriaLabel", "size", "type"]);
    const [isFocused, setIsFocused] = useState(false);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const isInputPassword = type === 'password';
    function handleFocus(event) {
        if (onFocus != null) {
            onFocus(event);
        }
        setIsFocused(true);
    }
    function handleBlur(event) {
        if (onBlur != null) {
            onBlur(event);
        }
        setIsFocused(false);
    }
    function renderIconLeft() {
        if (type === 'search') {
            return (_jsx(IconLeft, Object.assign({}, { size }, { children: _jsx(Search, { "data-testid": "search-icon", size: size === 'large' ? 'medium' : size }) })));
        }
        if (iconLeft != null) {
            return _jsx(IconLeft, Object.assign({}, { size }, { children: renderIcon(iconLeft, size) }));
        }
        return null;
    }
    function renderEnhancerRight() {
        if (isInputPassword) {
            return (_jsx(EnhancerRight, Object.assign({}, { size }, { children: _jsx(Enhancer, Object.assign({ "aria-label": passwordVisibilityAriaLabel({ isPasswordVisible }), disabled: disabled, onClick: () => setIsPasswordVisible(!isPasswordVisible), size: size }, { children: isPasswordVisible ? _jsx(Hidden, {}) : _jsx(Visible, {}) })) })));
        }
        if (enhancerRight != null) {
            // Disable custom enhancer when whole input is disabled by passing disabled prop
            return (_jsx(EnhancerRight, Object.assign({}, { size }, { children: renderIcon(enhancerRight, size, {
                    disabled,
                }) })));
        }
        return null;
    }
    return (_jsxs("div", Object.assign({ css: inputWrapperStyle({ disabled, inverted, isFocused, size }) }, { children: [renderIconLeft(), _jsx("input", Object.assign({}, restProps, (isInputPassword && {
                autoComplete: 'new-password',
                spellCheck: false,
            }), { "aria-invalid": error, css: inputStyle({
                    hasEnhancerRight: isInputPassword || !(enhancerRight == null),
                    hasError: error,
                    hasIconLeft: type === 'search' || !(iconLeft == null),
                    size,
                }), disabled: disabled, onBlur: handleBlur, onFocus: handleFocus, ref: ref, type: isPasswordVisible ? 'text' : type })), renderEnhancerRight()] })));
}
export default InputInternal;
